import i18nData from 'i2l?sync&query=sporks!../../../../lang/en.lyaml';
import { getLangEnabledLocales } from '../../internal/legacyI18nInit';
import { RegisterableIntlProvider } from '../../internal/hs-intl';

export default (Provider: RegisterableIntlProvider) =>
  Provider.register(i18nData as any, {
    getLocales: getLangEnabledLocales,
  });
